<div class="cargando-container">
  <div class="row">
    <div class="col-12" style="display: flex;justify-content: center;">
      <img [src]="logoUrl" alt="Logo" style="max-width: 320px; width: 60%; height: auto;"/>
    </div>
    <div class="col-12" style="display: flex;justify-content: center; margin-top: 12px; flex-direction: column; align-items:center; gap:8px;">
      <i class="fa-solid fa-spinner-third fa-spin" aria-label="Cargando"></i>
      <div style="color:#fff; font-weight:500; text-align:center;">{{mensaje}}</div>
    </div>
  </div>
</div>
